export const SEARCH_API_TAGS = {};
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
export const SEARCH_API_TAG_LIST = Object.values(SEARCH_API_TAGS);
